//API call to get the for the AI pipeline status
//import { getToken } from '../Utils/Common';

// export function getPipelineStatus(lv_id) {
//     return fetch(`${process.env.REACT_APP_BASE_URI}/api/handler/v2/resources/status/` + lv_id, {
//         method: 'GET',
//         headers: { 'Authorization': 'Bearer ' + getToken() }
//     })
//         .then(response => response.json())
//         .then(res => {
//             return res;
//         })
//         .catch((error) => {
//             console.error('Error:', error);
//         });
// }


//let apilink = "https://d25c1smh4gyzd4.cloudfront.net/"
//let apilink = "http://0.0.0.0:60/"

export async function getPipelineStatus(lv_id) {
    return fetch(`${process.env.REACT_APP_BASE_URI}/status/` + lv_id ,{
        method: 'GET',
        //headers: { 'Authorization': 'Bearer ' + getToken() }
        //body:JSON.stringify({"lv_id":lv_id})
    })
        .then(response => response.json())
        .then(res => {
            return res;
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}
